/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkUpdateOrganizationUserPrivilegesRequestUsersInner
 */
export interface BulkUpdateOrganizationUserPrivilegesRequestUsersInner {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateOrganizationUserPrivilegesRequestUsersInner
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateOrganizationUserPrivilegesRequestUsersInner
     */
    'userPrivilege': BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum;
}

export const BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum = typeof BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum[keyof typeof BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum];


